import { tv, VariantProps } from "@/utils";

export const hero = tv({
  slots: {
    base: [
      "relative",
      "overflow-hidden",
      "md:h-screen md:min-h-[650px]",
      "bg-green-900",
    ],
    background: ["object-cover", "select-none"],
    container: ["container-fluid", "h-full", "py-10"],
    content: [
      "relative",
      "w-full h-full",
      "pt-20 md:pt-0",
      "flex flex-col md:flex-row items-center",
      "gap-10 md:gap-0",
    ],
    caption: ["flex flex-col gap-6", "relative z-20", "md:max-w-4xl"],
    title: ["text-white"],
    description: ["text-gray-100", "md:max-w-sm"],
    figure: [
      "relative md:absolute md:inset-y-0 md:right-0 z-10",
      "m-auto",
      "overflow-hidden",
      "rounded-md",
      "aspect-square md:aspect-4/5",
      "w-full md:w-auto md:max-h-3/4",
    ],
    image: ["object-cover", "object-center"],
    isometricWrapper: [
      "absolute inset-y-0 -right-48 md:right-24 z-9",
      "aspect-5/6",
      "md:scale-150 -rotate-6 translate-y-2/6",
      "select-none",
    ],
    isometric: ["object-contain"],
  },
});

export type HeroVariantProps = VariantProps<typeof hero>;

export type HeroReturnVariantProps = ReturnType<typeof hero>;
